import './BlockSideBarList.css';
import { User } from '../../Header/elements/User/User';

export const BlockSideBarList = () => {
    return (
        <div className="block-side-bar-list">
            <div className="block-side-bar-list__header">
                <h2 className="block-side-bar-list__title">Сорвал Банк</h2>
            </div>
            <User />
        </div>
    );
};
